import { getChartLabel } from "./chartLabel";
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  Legend,
  XAxis,
  YAxis,
  Bar,
  BarChart,
  LabelList,
} from "recharts";

import { useState } from "react";
import { Form } from "react-bootstrap";
import CustomLegend from "./CustomLegend";
import CustomTooltip from "./CustomTooltip";

//kpi-5
const OST = ({ data, filters, selectedState }) => {
  const [showTable, setShowTable] = useState(false);
  const [sortColumn, setSortColumn] = useState("ost");
  const [sortOrder, setSortOrder] = useState("asc");

  if (!Array.isArray(data) || data.length === 0) {
    return (
      <div
        style={{
          textAlign: "center",
          padding: "40px",
          backgroundColor: "#fff",
          border: "1px solid #ddd",
          borderRadius: "8px",
          marginTop: "20px",
        }}
      >
        <h5 style={{ color: "#666", fontSize: "20px" }}>No data available</h5>
      </div>
    );
  }
  const ostData = data.map((item) => {
    return {
      place: item.Place,
      hrg: Number(item.HRG),
      new_registration: Number(item.new_registration),
      ost: Number(item.OST),
      new_registration_ost: Number(item.new_registration_OST) ?? 0,
    };
  });

  const sortedData = [...ostData].sort((a, b) => {
    if (sortColumn === "ost") {
      return sortOrder === "asc"
        ? a[sortColumn] - b[sortColumn]
        : b[sortColumn] - a[sortColumn];
    }
    return 0; // No sorting for other columns
  });

  // Handle sorting change
  const handleSort = (column) => {
    // if (column !== "ost") return; // Prevent sorting other columns
    if (sortColumn === column) {
      setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortColumn(column);
      setSortOrder("asc");
    }
  };

  const chunkArray = (array, chunkCount) => {
    const result = [];
    const chunkSize = Math.ceil(array.length / chunkCount);

    for (let i = 0; i < array.length; i += chunkSize) {
      result.push(array.slice(i, i + chunkSize));
    }

    return result;
  };

  const getChartCount = (length) => {
    if (length < 9) return 1;
    if (length >= 9 && length <= 18) return 2;
    if (length <= 45) return 3;
    return Math.ceil(length / 20);
  };

  const chartCount = getChartCount(ostData.length);
  const chunkedData = chunkArray(ostData, chartCount);

  return (
    <div style={{ width: "100%", position: "relative" }}>
      <div className="card hptCard mt-4 border-0">
        <div class="card-header brBtomlr">
          <div class="headnumText justify-content-between">
            <div class="cardTitle d-flex align-items-center gap-3 ">
              <h5>Prevention Services {getChartLabel(filters, selectedState)}</h5>
        
            </div>

            <div class="cardDropDown gap-3">
              <div style={{ marginRight: "10px", fontWeight: 500 }}>
                {showTable ? "Chart View" : "Table View"}
              </div>
              <Form>
                <Form.Check
                  type="switch"
                  id="chart-table-toggle"
                  onChange={() => setShowTable((prev) => !prev)}
                  checked={showTable}
                />
              </Form>
            </div>
          </div>
        </div>
      </div>
      {showTable ? (
        // Table View
        <div className="card hptCard mt-4 border-0">
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead className="thead-light">
                <tr>
                  <th className=" fw-bold ">Place</th>
                  <th
                    className="text-center fw-bold cursor-pointer"
                    // onClick={() => handleSort("hrg")}
                  >
                    HRG Bridge and Vulnerable Population Coverage{" "}
                    {/* {sortColumn === "hrg"
                      ? sortOrder === "asc"
                        ? "▲"
                        : "▼"
                      : "⬍"} */}
                  </th>
                  <th
                    className="text-center fw-bold cursor-pointer"
                    // onClick={() => handleSort("new_registration")}
                  >
                    New Registration of TI/LWS
                  </th>
                  <th
                    className="text-center fw-bold cursor-pointer"
                    // onClick={() => handleSort("ost")}
                  >
                    OST
                  </th>
                  <th
                    className="text-center fw-bold cursor-pointer"
                    // onClick={() => handleSort("new_registration_ost")}
                  >
                    New Registration of OST{" "}
                  </th>
                </tr>
              </thead>
              <tbody>
                {sortedData.map((item, idx) => (
                  <tr key={idx}>
                    <td className="fw-bold">{item.place}</td>
                    <td>{item.hrg}</td>
                    <td>{item.new_registration}</td>
                    <td>{item.ost}</td>
                    <td>{item.new_registration_ost}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        // Chart View
        <>
          {chunkedData.map((chunk, index) => (
            <div key={index} className="card hptCard mt-4 border-0">
              <div className="card-body">
                <h6 style={{ fontWeight: "bold" }}>
                  HRG Bridge and Vulnerable Population Coverage{" "}
                </h6>
              </div>

              <ResponsiveContainer width="100%" height={600}>
                <BarChart
                  width={500}
                  height={600}
                  data={chunk}
                  margin={{
                    top: 40,
                    right: 30,
                    left: 30,
                    bottom: 130,
                  }}
                >
                  <XAxis
                    dataKey="place"
                    angle={-90}
                    textAnchor="end"
                    interval={0}
                    label={{
                      value: "",
                      position: "insideBottom",
                      offset: -110,
                      color: "#ca8282ff",
                      fontWeight: "bold",
                    }}
                  />
                  <YAxis yAxisId="left" orientation="left" />
                  <Tooltip content={<CustomTooltip />} />
                  <Legend
                    verticalAlign="top"
                    content={<CustomLegend order={[]} />}
                  />
                  <Tooltip content={<CustomTooltip />} />
                  <Legend verticalAlign="top" content={<CustomLegend />} />
                  <Bar
                    yAxisId="left"
                    dataKey="hrg"
                    fill="#fd7e14"
                    name="HRG Bridge and Vulnerable Population Coverage"
                  >
                    <LabelList
                      dataKey="hrg"
                      position="top"
                      content={({ x, y, width, value }) => {
                        if (value == null) return null;
                        return (
                          <text
                            x={x + width / 2} // center horizontally
                            y={y - 5} // position slightly above bar
                            fontSize={12}
                            fontWeight="bold"
                            textAnchor="start" // 👈 could also try "middle" for alignment
                            transform={`rotate(-90, ${x + width / 2}, ${y - 5})`}
                          >
                            {value}
                          </text>
                        );
                      }}
                    />
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
          ))}
          {chunkedData.map((chunk, index) => (
            <div className="card hptCard mt-4 border-0">
              <div className="card-body">
                <h6 style={{ fontWeight: "bold" }}>
                  New registration of TI/LWS{" "}
                </h6>
              </div>
              <ResponsiveContainer width="100%" height={600}>
                <BarChart
                  width={500}
                  height={600}
                  data={chunk}
                  margin={{
                    top: 60,
                    right: 30,
                    left: 30,
                    bottom: 130,
                  }}
                >
                  <XAxis
                    dataKey="place"
                    angle={-90}
                    textAnchor="end"
                    interval={0}
                    label={{
                      value: "",
                      position: "insideBottom",
                      offset: -110,
                      color: "#ca8282ff",
                      fontWeight: "bold",
                    }}
                  />
                  <YAxis yAxisId="left" orientation="left" />
                  <Tooltip content={<CustomTooltip />} />
                  <Legend
                    verticalAlign="top"
                    content={<CustomLegend order={[]} />}
                  />
                  <Tooltip content={<CustomTooltip />} />
                  <Legend verticalAlign="top" content={<CustomLegend />} />
                  <Bar
                    yAxisId="left"
                    dataKey="new_registration"
                    fill="#00a084"
                    name="New registration of TI/LWS"
                  >
                    <LabelList
                      dataKey="new_registration"
                      position="top"
                      content={({ x, y, width, value }) => {
                        if (value == null) return null;
                        return (
                          <text
                            x={x + width / 2} // center horizontally
                            y={y - 5} // position slightly above bar
                            fontSize={12}
                            fontWeight="bold"
                            textAnchor="start" // 👈 could also try "middle" for alignment
                            transform={`rotate(-90, ${x + width / 2}, ${y - 5})`}
                          >
                            {value}
                          </text>
                        );
                      }}
                    />
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
          ))}
          {chunkedData.map((chunk, index) => (
            <div className="card hptCard mt-4 border-0">
              <div className="card-body">
                <h6 style={{ fontWeight: "bold" }}>Total IDU </h6>
              </div>
              <ResponsiveContainer width="100%" height={600}>
                <BarChart
                  width={500}
                  height={600}
                  data={chunk}
                  margin={{
                    top: 60,
                    right: 30,
                    left: 30,
                    bottom: 130,
                  }}
                >
                  <XAxis
                    dataKey="place"
                    angle={-90}
                    textAnchor="end"
                    interval={0}
                    label={{
                      value: "",
                      position: "insideBottom",
                      offset: -110,
                      color: "#ca8282ff",
                      fontWeight: "bold",
                    }}
                  />
                  <YAxis yAxisId="left" orientation="left" />
                  <Tooltip content={<CustomTooltip />} />
                  <Legend
                    verticalAlign="top"
                    content={<CustomLegend order={[]} />}
                  />
                  <Tooltip content={<CustomTooltip />} />
                  <Legend verticalAlign="top" content={<CustomLegend />} />

                  <Bar
                    yAxisId="left"
                    dataKey="ost"
                    fill="#ffc40c"
                    name="Total IDU"
                  >
                    <LabelList
                      dataKey="ost"
                      position="top"
                      content={({ x, y, width, value }) => {
                        if (value == null) return null;
                        return (
                          <text
                            x={x + width / 2} // center horizontally
                            y={y - 5} // position slightly above bar
                            fontSize={12}
                            fontWeight="bold"
                            textAnchor="start" // 👈 could also try "middle" for alignment
                            transform={`rotate(-90, ${x + width / 2}, ${y - 5})`}
                          >
                            {value}
                          </text>
                        );
                      }}
                    />
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
          ))}
          {chunkedData.map((chunk, index) => (
            <div className="card hptCard mt-4 border-0">
              <div className="card-body">
                <h6 style={{ fontWeight: "bold" }}>New registration in OST </h6>
              </div>
              <ResponsiveContainer width="100%" height={600}>
                <BarChart
                  width={500}
                  height={600}
                  data={chunk}
                  margin={{
                    top: 60,
                    right: 30,
                    left: 30,
                    bottom: 130,
                  }}
                >
                  <XAxis
                    dataKey="place"
                    angle={-90}
                    textAnchor="end"
                    interval={0}
                    label={{
                      value: "",
                      position: "insideBottom",
                      offset: -110,
                      color: "#ca8282ff",
                      fontWeight: "bold",
                    }}
                  />
                  <YAxis yAxisId="left" orientation="left" />
                  <Tooltip content={<CustomTooltip />} />
                  <Legend
                    verticalAlign="top"
                    content={<CustomLegend order={[]} />}
                  />
                  <Tooltip content={<CustomTooltip />} />
                  <Legend verticalAlign="top" content={<CustomLegend />} />
                  <Bar
                    yAxisId="left"
                    dataKey="new_registration_ost"
                    fill="#dd1e47"
                    name="New registration in OST"
                  >
                    <LabelList dataKey="new_registration_ost" position="top" />
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
          ))}
        </>
      )}
    </div>
  );
};
export default OST;
